import React from 'react';
import { Item } from 'react-stately/Item';
import { ItemProps } from '@react-types/shared';

export interface ListBoxItemProps<T> extends ItemProps<T> {
  /**
   * Icon place on the right side of the ListBox item.
   */
  rightIcon?: React.ReactNode;
  /**
   * Icon place on the left side of the ListBox item.
   */
  leftIcon?: React.ReactNode;
  /**
   * @deprecated Use `rightIcon` instead
   */
  icon?: React.ReactNode;
  /**
   * @deprecated Will be removed in a future major version
   */
  avatar?: React.ReactNode;
  /**
   * Secondary text with less emphasised style, rendered below the main content.
   */
  secondaryText?: React.ReactNode;
}

const ListBoxItem = Item as <T>(props: ListBoxItemProps<T>) => JSX.Element;

export { ListBoxItem };
